// Users
export const selectUsersInitialized = (state) =>
  !state.users.loading && state.users.users.length >= 1;
export const selectUsersLoading = (state) => state.users.loading;
export const selectCurrentUserId = (state) => state.users.currentUserId;
export const selectAllUsers = (state) => state.users.users;
